/* tslint:disable */
/* eslint-disable */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}
